import { useMarkdown } from '@features/markdown';
import { useEffect } from 'react';
import classNames from 'classnames';

type MarkdownProps = {
  source: string;
  className?: string;
  placeholders?: any;
  unwrapParagraphs?: boolean;
};

export function Markdown({ source: rawSource, placeholders, className, unwrapParagraphs = false }: MarkdownProps) {
  const [content, setSource] = useMarkdown({ placeholders, unwrapParagraphs });

  const isString = typeof rawSource === 'string';
  const source =  isString ? rawSource : '';

  useEffect(() => {
    setSource(source);
  }, [source, placeholders]);

  return <div className={classNames('markdown', className)}>{isString ? content: rawSource}</div>;
}
